(function(){
  var nav=document.querySelector('[data-nm]'); if(!nav||nav.dataset.ready) return; nav.dataset.ready='1';
  var items=[].slice.call(nav.querySelectorAll('[data-nm-item]')), timer=null, canHover=window.matchMedia('(hover:hover)').matches;
  function place(){ document.documentElement.style.setProperty('--nm-top',(nav.getBoundingClientRect().bottom+6)+'px'); }
  function close(it){ it.classList.remove('is-open'); var a=it.querySelector('.nm-top'); if(a) a.setAttribute('aria-expanded','false'); }
  function closeAll(except){ items.forEach(function(it){ if(it!==except) close(it); }); }
  function open(it){ clearTimeout(timer); place(); closeAll(it); it.classList.add('is-open'); it.querySelector('.nm-top').setAttribute('aria-expanded','true'); }
  items.forEach(function(it){
    var top=it.querySelector('.nm-top'), panel=it.querySelector('[data-nm-panel]');
    function pick(c){
      var id=c.getAttribute('data-nm-cat');
      [].forEach.call(it.querySelectorAll('[data-nm-cat]'),function(x){ x.classList.toggle('is-on',x===c); });
      [].forEach.call(it.querySelectorAll('[data-nm-catpane]'),function(p){ p.hidden=p.getAttribute('data-nm-catpane')!==id; });
    }
    if(canHover){
      it.addEventListener('mouseenter',function(){ clearTimeout(timer); timer=setTimeout(function(){ open(it); },80); });
      it.addEventListener('mouseleave',function(){ clearTimeout(timer); timer=setTimeout(function(){ close(it); },220); });
    }
    top.addEventListener('click',function(ev){ if(!it.classList.contains('is-open')){ ev.preventDefault(); open(it); } });
    top.addEventListener('keydown',function(ev){ if(ev.key==='ArrowDown'){ ev.preventDefault(); open(it); var f=panel.querySelector('button,a'); if(f) f.focus(); } });
    it.addEventListener('focusout',function(){ setTimeout(function(){ if(!it.contains(document.activeElement)) close(it); },0); });
    [].forEach.call(it.querySelectorAll('[data-nm-tab]'),function(tb){
      tb.addEventListener('click',function(){
        var id=tb.getAttribute('data-nm-tab');
        [].forEach.call(it.querySelectorAll('[data-nm-tab]'),function(x){ x.classList.toggle('is-on',x===tb); });
        [].forEach.call(it.querySelectorAll('[data-nm-tabpane]'),function(p){ p.hidden=p.getAttribute('data-nm-tabpane')!==id; });
        var first=it.querySelector('[data-nm-tabpane="'+id+'"] [data-nm-cat]'); if(first) pick(first);
      });
    });
    [].forEach.call(it.querySelectorAll('[data-nm-cat]'),function(c){
      c.addEventListener('mouseenter',function(){ pick(c); });
      c.addEventListener('focus',function(){ pick(c); });
      c.addEventListener('click',function(){ pick(c); });
    });
  });
  document.addEventListener('keydown',function(ev){ if(ev.key==='Escape') closeAll(); });
  document.addEventListener('click',function(ev){ if(!nav.contains(ev.target)) closeAll(); });
  window.addEventListener('scroll',function(){ if(nav.querySelector('.is-open')) place(); },{passive:true});
  window.addEventListener('resize',place);
})();
